/**
 * https://github.com/github/fetch#handling-http-error-statuses
 *
 * @param response
 * @returns {*}
 */
export default function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}
